/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Goodforparty2Inputs */

const en_goodforparty2 = /** @type {(inputs: Goodforparty2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Party`)
};

const de_goodforparty2 = /** @type {(inputs: Goodforparty2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Party`)
};

/**
* | output |
* | --- |
* | "Party" |
*
* @param {Goodforparty2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const goodforparty2 = /** @type {((inputs?: Goodforparty2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Goodforparty2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_goodforparty2(inputs)
	return de_goodforparty2(inputs)
});
export { goodforparty2 as "goodForParty" }